<template>
  <div style="background-color: var(--color-surface)">
    <template>
      <v-list-item v-for="alert in filteredAlerts" :key="alert.id" class="mb-2">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">
                  {{ alert.title }}
                </v-list-item-title>
                <div class="d-flex align-center">
                  <v-list-item-subtitle class="alert-description">
                    {{ alert.description }}
                  </v-list-item-subtitle>
                  <v-chip
                    small
                    class="mt-n5 mr-5"
                    :color="alert.active ? 'success' : 'grey'"
                    :text-color="alert.active ? 'white' : ''"
                  >
                    {{ alert.active ? "Enabled" : "Disabled" }}
                  </v-chip>
                </div>
              </v-list-item-content>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-switch
                    v-model="alert.active"
                    class="mb-2 mr-2 switch-alert"
                    @change="setAlertEnabled(alert.id, $event)"
                    label="Enable Alert"
                  ></v-switch>
                </v-col>
                <template v-if="alert.active">
                  <div
                    style="
                      display: flex;
                      flex-direction: row;
                      justify-content: space-between;
                      border-radius: 5px;
                      width: 50%;
                      padding: 0px;
                    "
                  >
                    <ThemedTextField
                      v-model.number="alert.lowerLimit"
                      label="Lower Limit"
                      type="number"
                      outlined
                      dense
                      @change="setAlertLowerLimit(alert.id, $event)"
                    ></ThemedTextField>
                    <div style="width: 20px"></div>
                    <ThemedTextField
                      v-model.number="alert.upperLimit"
                      label="Upper Limit"
                      type="number"
                      outlined
                      dense
                      @change="setAlertUpperLimit(alert.id, $event)"
                    ></ThemedTextField>
                  </div>
                </template>
                <v-col cols="12">
                  <div
                    style="display: flex; flex-direction: column; width: 50%"
                  >
                    <ThemedCheckbox
                      class="mb-2 mr-2"
                      @change="setAlertSendEmail(alert.id, $event)"
                      label="Send Email"
                      v-model="alert.sendEmail"
                      :input-value="alert.sendEmail"
                    ></ThemedCheckbox>
                    <ThemedTextField
                      label="Receiver Email"
                      type="email"
                      outlined
                      dense
                      @change="setAlertReceiverEmail(alert.id, $event)"
                      v-model="alert.receiverEmail"
                    ></ThemedTextField>
                  </div>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-list-item>
    </template>
  </div>
</template>
    
  <script>
import { mapState, mapGetters } from "vuex";
import ThemedCheckbox from "@/core/ThemedCheckbox.vue";
import ThemedTextField from "@/core/ThemedTextField.vue";
export default {
  name: "AlertsList",
  components: {
    ThemedCheckbox,
    ThemedTextField,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("alerts", ["alerts", "selectedCategory", "categories"]),
    ...mapGetters("alerts", ["filteredAlerts"]),
    currentCategory() {
      return this.categories.find((cat) => cat.id === this.selectedCategory);
    },
  },
  methods: {
    setAlertUpperLimit(alertId, upperLimit) {
      this.$store.commit("alerts/SET_ALERT_UPPER_LIMIT", {
        id: alertId,
        upperLimit: upperLimit,
      });
    },
    setAlertLowerLimit(alertId, lowerLimit) {
      this.$store.commit("alerts/SET_ALERT_LOWER_LIMIT", {
        id: alertId,
        lowerLimit: lowerLimit,
      });
    },
    setAlertEnabled(alertId, active) {
      this.$store.commit("alerts/SET_ALERT_ENABLED", {
        id: alertId,
        active: active,
      });
    },
    setAlertSendEmail(alertId, sendEmail) {
      this.$store.commit("alerts/SET_ALERT_SEND_EMAIL", {
        id: alertId,
        sendEmail: sendEmail,
      });
    },
    setAlertReceiverEmail(alertId, receiverEmail) {
      this.$store.commit("alerts/SET_ALERT_RECEIVER_EMAIL", {
        id: alertId,
        receiverEmail: receiverEmail,
      });
    },
  },
};
</script>
    
<style scoped>
.v-list {
  background-color: var(--color-surface);
  position: relative;
}
.alert-description {
  color: var(--color-text-muted) !important;
}

/* Theme the alert switch */
.switch-alert::v-deep .v-label {
  color: var(--color-text) !important;
}

.switch-alert::v-deep .v-input--is-label-active .v-input--switch__track {
  background-color: var(--color-secondary-light) !important;
}

.fixed-header {
  position: sticky;
  top: 0;
  background-color: var(--color-surface);
  z-index: 1;
}

/* Theme the expansion panels */
.v-expansion-panels::v-deep .v-expansion-panel {
  background-color: var(--color-surface) !important;
  border: 1px solid var(--color-border) !important;
  border-radius: var(--radius-md) !important;
  margin-bottom: 8px;
}

.v-expansion-panels::v-deep .v-expansion-panel-header {
  background-color: var(--color-surface) !important;
  color: var(--color-text) !important;
  border-radius: var(--radius-md) !important;
  padding: 16px 20px;
}

.v-expansion-panels::v-deep .v-expansion-panel-header:hover {
  background-color: var(--color-surface-light) !important;
}

.v-expansion-panels::v-deep .v-expansion-panel-header--active {
  background-color: var(--color-surface-light) !important;
  border-bottom: 1px solid var(--color-border) !important;
}

.v-expansion-panels::v-deep .v-expansion-panel-content {
  background-color: var(--color-surface) !important;
  border-top: 1px solid var(--color-border) !important;
}

.v-expansion-panels::v-deep .v-expansion-panel-content__wrap {
  padding: 20px;
  color: var(--color-text) !important;
}

/* Theme list item titles and subtitles */
.v-list-item-title {
  color: var(--color-text) !important;
  font-weight: 500;
}

.v-list-item-subtitle {
  color: var(--color-text-muted) !important;
}

.v-expansion-panels::v-deep .v-expansion-panel-header__icon:hover {
  color: var(--color-secondary-light) !important;
}

.v-expansion-panels::v-deep .v-expansion-panel-header__icon .v-icon {
  color: var(--color-secondary) !important;
  transition: transform var(--transition-default) !important;
  transform: rotate(0deg) !important;
}

.v-expansion-panels::v-deep
  .v-expansion-panel-header--active
  .v-expansion-panel-header__icon {
  color: var(--color-secondary) !important;
  transform: rotate(-180deg) !important;
}

.v-expansion-panels::v-deep .v-expansion-panel-header {
  position: relative;
}

.v-expansion-panels::v-deep .v-expansion-panel-header__icon::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: transparent;
  transition: var(--transition-default);
  z-index: -1;
}

.v-expansion-panels::v-deep
  .v-expansion-panel-header:hover
  .v-expansion-panel-header__icon::before {
  background-color: var(--color-secondary-light);
  opacity: 0.1;
}

.v-expansion-panels::v-deep
  .v-expansion-panel-header--active
  .v-expansion-panel-header__icon::before {
  background-color: var(--color-secondary);
  opacity: 0.15;
}
</style>
      
    
      
      